import { useFilter } from "../../../fetch/fetch.filter.ts";
import { EMPTY_FILTER } from "../../../const/typeDefault/Filter.ts";
import LoadingLine from "../../core/loading/LoadingLine.tsx";
import ErrMessage from "../../core/ErrMessage.tsx";

const FilterUnit = ({ id }: { id: string }) => {
  const { filter, isLoading, isError } = useFilter(id, EMPTY_FILTER);
  if (isLoading) return <LoadingLine description="..." />;
  if (isError) return <ErrMessage message={isError.message} />;
  return filter.unit;
};
export default FilterUnit;
